__turbopack_context__.v({
  "Accordion_content-container__4C389": "svrBza_Accordion_content-container__4C389",
  "anchor-child": "svrBza_anchor-child",
  "arrow-button": "svrBza_arrow-button",
  "block-filter": "svrBza_block-filter",
  "block-filter-pwa": "svrBza_block-filter-pwa",
  "breadcrumb-wrapper": "svrBza_breadcrumb-wrapper",
  "card-selected": "svrBza_card-selected",
  "categories-slider": "svrBza_categories-slider",
  "enriched-content-block": "svrBza_enriched-content-block",
  "filtersHidden": "svrBza_filtersHidden",
  "header": "svrBza_header",
  "load-more": "svrBza_load-more",
  "load-more-hidden": "svrBza_load-more-hidden",
  "load-more-retry": "svrBza_load-more-retry",
  "load-more-retry-button": "svrBza_load-more-retry-button",
  "load-more-wrapper": "svrBza_load-more-wrapper",
  "main": "svrBza_main",
  "name": "svrBza_name",
  "next": "svrBza_next",
  "plp-grid-override": "svrBza_plp-grid-override",
  "prev": "svrBza_prev",
  "product-listing-page": "svrBza_product-listing-page",
  "products-amount-bar": "svrBza_products-amount-bar",
  "recently-viewed": "svrBza_recently-viewed",
  "sidebar-filters": "svrBza_sidebar-filters",
  "slider-item": "svrBza_slider-item",
  "slider-square": "svrBza_slider-square",
  "title-container": "svrBza_title-container",
  "viewing-count-label": "svrBza_viewing-count-label",
});
